// @flow

import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import glamorous from 'glamorous'
import { css } from 'glamor'
import getContent from 'pp-react-l10n'
import axios from 'axios'
import { Modal, Button } from '@paypalcorp/pp-react'

import { ILLUSTRATIONS } from 'utils/constants'

import {
  init as initSessionTimer,
  onSessionExtended,
} from 'utils/session-timer'

const STYLES = {
  MODAL: css({ zIndex: 99999 }),
}

const Wrapper = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
})
const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

const ButtonContainer = glamorous.div({ marginTop: '2rem' })

const l10n = getContent('pages/session-timer')

function SessionTimer() {
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    initSessionTimer({
      onWarning: () => {
        setIsOpen(true)
      },
    })
  }, [])

  const onClose = () => {
    setIsOpen(false)
  }

  const onSubmit = async () => {
    // double check since React does not guarantee renders between event boundaries
    if (isLoading) {
      return
    }

    setIsLoading(true)

    try {
      await axios('/auth/extend')

      onSessionExtended()

      ReactDOM.unstable_batchedUpdates(() => {
        setIsLoading(false)
        setIsOpen(false)
      })
    } catch (e) {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      hideLogo={true}
      title={l10n('session.all_done')}
      hideTitle={true}
      className={`${STYLES.MODAL}`}
      overpanel
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackgroundClick={false}
      closeButtonLabel={l10n('overpanel.close')}
    >
      <Wrapper>
        <Container>
          <img src={ILLUSTRATIONS.WARNING} alt="" width="75px" height="75px" />
          <h2>{l10n('session.all_done')}</h2>
          <span>{l10n('session.we_will_log_you_out')}</span>
          <ButtonContainer>
            <Button disabled={isLoading} onClick={onSubmit}>
              {l10n('session.stay_logged_in')}
            </Button>
          </ButtonContainer>
        </Container>
      </Wrapper>
    </Modal>
  )
}

export default SessionTimer
